var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9258_4",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9258_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.375 21.825C13.5583 21.875 13.7708 21.8958 14.0125 21.8875C14.2542 21.8792 14.4583 21.8417 14.625 21.775L22 19C22 18.4333 21.8 17.9583 21.4 17.575C21 17.1917 20.5333 17 20 17H13.15C13.1 17 13.0417 16.9958 12.975 16.9875C12.9083 16.9792 12.8583 16.9667 12.825 16.95L11.35 16.425C11.2167 16.375 11.125 16.2917 11.075 16.175C11.025 16.0583 11.0167 15.9333 11.05 15.8C11.0833 15.6833 11.1667 15.5917 11.3 15.525C11.4333 15.4583 11.5667 15.45 11.7 15.5L12.825 15.925C12.8917 15.9583 12.9458 15.9792 12.9875 15.9875C13.0292 15.9958 13.0917 16 13.175 16H15.8C16.1167 16 16.3958 15.8917 16.6375 15.675C16.8792 15.4583 17 15.175 17 14.825C17 14.5917 16.9292 14.3667 16.7875 14.15C16.6458 13.9333 16.4583 13.7833 16.225 13.7L9.3 11.125C9.18333 11.0917 9.06667 11.0625 8.95 11.0375C8.83333 11.0125 8.71667 11 8.6 11H7V20.025L13.375 21.825ZM1 20C1 20.55 1.19583 21.0208 1.5875 21.4125C1.97917 21.8042 2.45 22 3 22C3.55 22 4.02083 21.8042 4.4125 21.4125C4.80417 21.0208 5 20.55 5 20V13C5 12.45 4.80417 11.9792 4.4125 11.5875C4.02083 11.1958 3.55 11 3 11C2.45 11 1.97917 11.1958 1.5875 11.5875C1.19583 11.9792 1 12.45 1 13V20ZM16 12.2C15.75 12.2 15.5042 12.1542 15.2625 12.0625C15.0208 11.9708 14.8 11.8333 14.6 11.65L11.85 8.95C11.3333 8.45 10.8958 7.89583 10.5375 7.2875C10.1792 6.67917 10 6.01667 10 5.3C10 4.38333 10.3208 3.60417 10.9625 2.9625C11.6042 2.32083 12.3833 2 13.3 2C13.8333 2 14.3333 2.1125 14.8 2.3375C15.2667 2.5625 15.6667 2.86667 16 3.25C16.3333 2.86667 16.7333 2.5625 17.2 2.3375C17.6667 2.1125 18.1667 2 18.7 2C19.6167 2 20.3958 2.32083 21.0375 2.9625C21.6792 3.60417 22 4.38333 22 5.3C22 6.01667 21.825 6.67917 21.475 7.2875C21.125 7.89583 20.6917 8.45 20.175 8.95L17.4 11.65C17.2 11.8333 16.9792 11.9708 16.7375 12.0625C16.4958 12.1542 16.25 12.2 16 12.2Z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonate);
export default __webpack_public_path__ + "static/media/donate.05ef0b408cd3a7c3601bb92758a12a23.svg";
export { ForwardRef as ReactComponent };